
import { defineComponent, reactive, toRefs } from "vue";
import SvgIcon from "@/svgIcon/index.vue";
export default defineComponent({
  props: ["titleType", "productModule", "productTitleDesc", "productModuleImg"],
  setup(props) {
    const data = reactive({
      productUrl: "",
      productIndex: 0,
      show: true,
      style: Math.round(Math.random()) == 1 ? "bounce1" : "bounce"
    });
    setInterval(
      () => {
        let index = 0;
        if (data.productIndex < 4) {
          index = data.productIndex + 1;
        } else {
          index = 0;
        }
        const detail = props.productModule.articles[index];
        data.productUrl = detail.img;
        data.productIndex = index;
        data.show = !data.show;
      },
      props.titleType == true ? 10000 : 11000
    );
    //产品点击事件
    const product = (url: string, index: number) => {
      if (data.productIndex != index) {
        data.show = !data.show;
      }
      data.productIndex = index;
      data.productUrl = url;
    };
    return {
      ...toRefs(data),
      product
    };
  },
  components: { SvgIcon }
});
